class Drilldown {
    id: number;
    name: string;
    isAggregative: boolean;
    order: number;
    mappingTemplate: boolean;
    source: number;
    disabled: KnockoutObservable<boolean>;
    visibility: VisibilityEnum;
    visible: KnockoutObservable<boolean>;

    /**
     * Create a new Drilldown object
     * @param data a Drilldown or any object with same properties as Drilldown
     * @param useDisabledAsBoolean used for dxList, disable property is set direct to boolean (Gambiarra)
     */
    constructor(data: any) {
        this.id = data.id;
        this.name = data.displayName ?? data.name;
        this.isAggregative = data.isAggregative;
        this.order = data.order;
        this.mappingTemplate = data.mappingTemplate ?? true;
        this.source = data.source ?? 0;
        this.visibility = data.visibility ?? VisibilityEnum.Normal;

        if (data.disabled !== undefined) {
            if (typeof data.disabled === "boolean") {
                this.disabled = ko.observable(data.disabled);
            }
            else {
                this.disabled = ko.observable(data.disabled());
            }
        }
        else {
            this.disabled = ko.observable(false);
        }

        if (data.visible !== undefined) {
            if (typeof data.visible === "boolean") {
                this.visible = ko.observable(data.visible);
            }
            else {
                this.visible = data.visible;
            }
        }
        else {
            this.visible = ko.observable(true);
        }
    }
}